import { render, staticRenderFns } from "./ServiceFee.vue?vue&type=template&id=b60eca1c&scoped=true"
import script from "./ServiceFee.vue?vue&type=script&lang=js"
export * from "./ServiceFee.vue?vue&type=script&lang=js"
import style0 from "./ServiceFee.vue?vue&type=style&index=0&id=b60eca1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60eca1c",
  null
  
)

export default component.exports